import { AbTestConfiguration, AbTestConfigurationInput } from '@pubstack/common/src/abTest'
import { useMutation, useQuery } from '~/api/api-client'

export const AB_TEST_QUERY_KEYS = ['settings', 'ab-tests']
const url = '/ab-test-configuration'

//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------
export const useAbTests = () => useQuery<AbTestConfiguration[]>({ url, keys: AB_TEST_QUERY_KEYS })

export const useAbTest = (id: string) => useQuery<AbTestConfiguration>({ url: `${url}/${id}`, keys: [...AB_TEST_QUERY_KEYS, id], enabled: !!id })

//-------------------------------------------------------------------------
// Mutations
//-------------------------------------------------------------------------
/** The server sets the scope, and the test starts disabled */
export const useCreateAbTest = () => useMutation<AbTestConfigurationInput, AbTestConfiguration>({ method: 'post', url, collectionKeys: AB_TEST_QUERY_KEYS })

/** Owners only. Only one test runs per scope: activating one disables the live one, server side */
export const useToggleAbTest = () =>
  useMutation<Pick<AbTestConfiguration, 'id'>, AbTestConfiguration>({ method: 'put', url: ({ id }) => `${url}/toggleStatus/${id}`, collectionKeys: AB_TEST_QUERY_KEYS })

/** Owners only for the live test */
export const useDeleteAbTest = () => useMutation<Pick<AbTestConfiguration, 'id'>>({ method: 'delete', url: ({ id }) => `${url}/${id}`, collectionKeys: AB_TEST_QUERY_KEYS })
